/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PortabilidadeEgrCriteriaDto } from '../models/portabilidade-egr-criteria-dto';
import { PortabilidadeEgrDto } from '../models/portabilidade-egr-dto';
import { PortabilidadeEgrFormDto } from '../models/portabilidade-egr-form-dto';
import { PortabilidadeEgrPageDto } from '../models/portabilidade-egr-page-dto';

@Injectable({
  providedIn: 'root',
})
export class PortabilidadeEgrService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getPortabilidadesEgr
   */
  static readonly GetPortabilidadesEgrPath = '/portabilidades-egr';

  /**
   * Pesquisar portabilidades.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPortabilidadesEgr()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortabilidadesEgr$Response(params?: {
    criteria?: PortabilidadeEgrCriteriaDto;
  }): Observable<StrictHttpResponse<PortabilidadeEgrPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, PortabilidadeEgrService.GetPortabilidadesEgrPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortabilidadeEgrPageDto>;
      })
    );
  }

  /**
   * Pesquisar portabilidades.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPortabilidadesEgr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortabilidadesEgr(params?: {
    criteria?: PortabilidadeEgrCriteriaDto;
  }): Observable<PortabilidadeEgrPageDto> {

    return this.getPortabilidadesEgr$Response(params).pipe(
      map((r: StrictHttpResponse<PortabilidadeEgrPageDto>) => r.body as PortabilidadeEgrPageDto)
    );
  }

  /**
   * Path part for operation createPortabilidadeEgr
   */
  static readonly CreatePortabilidadeEgrPath = '/portabilidades-egr';

  /**
   * Criar portabilidade EGR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPortabilidadeEgr()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPortabilidadeEgr$Response(params?: {

    /**
     * apiRequest
     */
    body?: PortabilidadeEgrFormDto
  }): Observable<StrictHttpResponse<PortabilidadeEgrDto>> {

    const rb = new RequestBuilder(this.rootUrl, PortabilidadeEgrService.CreatePortabilidadeEgrPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortabilidadeEgrDto>;
      })
    );
  }

  /**
   * Criar portabilidade EGR.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createPortabilidadeEgr$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPortabilidadeEgr(params?: {

    /**
     * apiRequest
     */
    body?: PortabilidadeEgrFormDto
  }): Observable<PortabilidadeEgrDto> {

    return this.createPortabilidadeEgr$Response(params).pipe(
      map((r: StrictHttpResponse<PortabilidadeEgrDto>) => r.body as PortabilidadeEgrDto)
    );
  }

  /**
   * Path part for operation getPortabilidadeEgr
   */
  static readonly GetPortabilidadeEgrPath = '/portabilidades-egr/{id}';

  /**
   * Obter portabilidade EGR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPortabilidadeEgr()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortabilidadeEgr$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<PortabilidadeEgrDto>> {

    const rb = new RequestBuilder(this.rootUrl, PortabilidadeEgrService.GetPortabilidadeEgrPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortabilidadeEgrDto>;
      })
    );
  }

  /**
   * Obter portabilidade EGR.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPortabilidadeEgr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPortabilidadeEgr(params: {
    id: number;
  }): Observable<PortabilidadeEgrDto> {

    return this.getPortabilidadeEgr$Response(params).pipe(
      map((r: StrictHttpResponse<PortabilidadeEgrDto>) => r.body as PortabilidadeEgrDto)
    );
  }

  /**
   * Path part for operation updatePortabilidadeEgr
   */
  static readonly UpdatePortabilidadeEgrPath = '/portabilidades-egr/{id}';

  /**
   * Alterar portabilidade EGR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePortabilidadeEgr()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePortabilidadeEgr$Response(params: {
    id: number;
    body?: PortabilidadeEgrFormDto
  }): Observable<StrictHttpResponse<PortabilidadeEgrDto>> {

    const rb = new RequestBuilder(this.rootUrl, PortabilidadeEgrService.UpdatePortabilidadeEgrPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortabilidadeEgrDto>;
      })
    );
  }

  /**
   * Alterar portabilidade EGR.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updatePortabilidadeEgr$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePortabilidadeEgr(params: {
    id: number;
    body?: PortabilidadeEgrFormDto
  }): Observable<PortabilidadeEgrDto> {

    return this.updatePortabilidadeEgr$Response(params).pipe(
      map((r: StrictHttpResponse<PortabilidadeEgrDto>) => r.body as PortabilidadeEgrDto)
    );
  }

  /**
   * Path part for operation ativarPortabilidadeEgr
   */
  static readonly AtivarPortabilidadeEgrPath = '/portabilidades-egr/{id}/ativar';

  /**
   * Ativar portabilidade EGR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarPortabilidadeEgr()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarPortabilidadeEgr$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<PortabilidadeEgrDto>> {

    const rb = new RequestBuilder(this.rootUrl, PortabilidadeEgrService.AtivarPortabilidadeEgrPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortabilidadeEgrDto>;
      })
    );
  }

  /**
   * Ativar portabilidade EGR.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarPortabilidadeEgr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarPortabilidadeEgr(params: {
    id: number;
  }): Observable<PortabilidadeEgrDto> {

    return this.ativarPortabilidadeEgr$Response(params).pipe(
      map((r: StrictHttpResponse<PortabilidadeEgrDto>) => r.body as PortabilidadeEgrDto)
    );
  }

  /**
   * Path part for operation desativarPortabilidadeEgr
   */
  static readonly DesativarPortabilidadeEgrPath = '/portabilidades-egr/{id}/desativar';

  /**
   * Desativar portabilidade EGR.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarPortabilidadeEgr()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarPortabilidadeEgr$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<PortabilidadeEgrDto>> {

    const rb = new RequestBuilder(this.rootUrl, PortabilidadeEgrService.DesativarPortabilidadeEgrPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PortabilidadeEgrDto>;
      })
    );
  }

  /**
   * Desativar portabilidade EGR.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarPortabilidadeEgr$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarPortabilidadeEgr(params: {
    id: number;
  }): Observable<PortabilidadeEgrDto> {

    return this.desativarPortabilidadeEgr$Response(params).pipe(
      map((r: StrictHttpResponse<PortabilidadeEgrDto>) => r.body as PortabilidadeEgrDto)
    );
  }

}
